/* tslint:disable */
/* eslint-disable */
/**
 * Hyper GES API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  AnteprimaDto,
  FilterBuilderDto,
  FiltroCreateDTO,
  FiltroDTO,
  FiltroUpdateDTO,
  ProblemDetails,
} from '../models/index';
import {
    AnteprimaDtoFromJSON,
    AnteprimaDtoToJSON,
    FilterBuilderDtoFromJSON,
    FilterBuilderDtoToJSON,
    FiltroCreateDTOFromJSON,
    FiltroCreateDTOToJSON,
    FiltroDTOFromJSON,
    FiltroDTOToJSON,
    FiltroUpdateDTOFromJSON,
    FiltroUpdateDTOToJSON,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
} from '../models/index';

export interface DeleteFiltroRequest {
    filtroId: string;
    tenantId: string;
}

export interface GetDataFromEspressioneRequest {
    tenantId: string;
    espressione?: string;
}

export interface GetDataFromFilterIdRequest {
    tenantId: string;
    filtroId: string;
}

export interface GetFieldsRequest {
    tenantId: string;
}

export interface GetFiltriRequest {
    tenantId: string;
}

export interface GetFiltroByIdRequest {
    filtroId: string;
    tenantId: string;
}

export interface InsertFiltroRequest {
    tenantId: string;
    filtroCreateDTO?: FiltroCreateDTO;
}

export interface UpdateFiltroRequest {
    filtroId: string;
    tenantId: string;
    filtroUpdateDTO?: FiltroUpdateDTO;
}

/**
 * 
 */
export class FiltriApi extends runtime.BaseAPI {

    /**
     */
    async deleteFiltroRaw(requestParameters: DeleteFiltroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filtroId'] == null) {
            throw new runtime.RequiredError(
                'filtroId',
                'Required parameter "filtroId" was null or undefined when calling deleteFiltro().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling deleteFiltro().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Filtri/{filtroId}`.replace(`{${"filtroId"}}`, encodeURIComponent(String(requestParameters['filtroId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async deleteFiltro(requestParameters: DeleteFiltroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteFiltroRaw(requestParameters, initOverrides);
    }

    /**
     */
    async getDataFromEspressioneRaw(requestParameters: GetDataFromEspressioneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnteprimaDto>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getDataFromEspressione().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['espressione'] != null) {
            queryParameters['espressione'] = requestParameters['espressione'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Filtri/data`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnteprimaDtoFromJSON(jsonValue));
    }

    /**
     */
    async getDataFromEspressione(requestParameters: GetDataFromEspressioneRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnteprimaDto> {
        const response = await this.getDataFromEspressioneRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getDataFromFilterIdRaw(requestParameters: GetDataFromFilterIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<AnteprimaDto>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getDataFromFilterId().'
            );
        }

        if (requestParameters['filtroId'] == null) {
            throw new runtime.RequiredError(
                'filtroId',
                'Required parameter "filtroId" was null or undefined when calling getDataFromFilterId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Filtri/{filtroId}/data`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))).replace(`{${"filtroId"}}`, encodeURIComponent(String(requestParameters['filtroId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => AnteprimaDtoFromJSON(jsonValue));
    }

    /**
     */
    async getDataFromFilterId(requestParameters: GetDataFromFilterIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<AnteprimaDto> {
        const response = await this.getDataFromFilterIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFieldsRaw(requestParameters: GetFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FilterBuilderDto>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getFields().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Filtri/fields`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FilterBuilderDtoFromJSON(jsonValue));
    }

    /**
     */
    async getFields(requestParameters: GetFieldsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FilterBuilderDto> {
        const response = await this.getFieldsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFiltriRaw(requestParameters: GetFiltriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<FiltroDTO>>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getFiltri().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Filtri`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(FiltroDTOFromJSON));
    }

    /**
     */
    async getFiltri(requestParameters: GetFiltriRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<FiltroDTO>> {
        const response = await this.getFiltriRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async getFiltroByIdRaw(requestParameters: GetFiltroByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<FiltroDTO>> {
        if (requestParameters['filtroId'] == null) {
            throw new runtime.RequiredError(
                'filtroId',
                'Required parameter "filtroId" was null or undefined when calling getFiltroById().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling getFiltroById().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Filtri/{filtroId}`.replace(`{${"filtroId"}}`, encodeURIComponent(String(requestParameters['filtroId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FiltroDTOFromJSON(jsonValue));
    }

    /**
     */
    async getFiltroById(requestParameters: GetFiltroByIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<FiltroDTO> {
        const response = await this.getFiltroByIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async insertFiltroRaw(requestParameters: InsertFiltroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling insertFiltro().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Filtri`.replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FiltroCreateDTOToJSON(requestParameters['filtroCreateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async insertFiltro(requestParameters: InsertFiltroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.insertFiltroRaw(requestParameters, initOverrides);
    }

    /**
     */
    async updateFiltroRaw(requestParameters: UpdateFiltroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['filtroId'] == null) {
            throw new runtime.RequiredError(
                'filtroId',
                'Required parameter "filtroId" was null or undefined when calling updateFiltro().'
            );
        }

        if (requestParameters['tenantId'] == null) {
            throw new runtime.RequiredError(
                'tenantId',
                'Required parameter "tenantId" was null or undefined when calling updateFiltro().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            // oauth required
            headerParameters["Authorization"] = await this.configuration.accessToken("Bearer", []);
        }

        const response = await this.request({
            path: `/tenants/{tenantId}/Filtri/{filtroId}`.replace(`{${"filtroId"}}`, encodeURIComponent(String(requestParameters['filtroId']))).replace(`{${"tenantId"}}`, encodeURIComponent(String(requestParameters['tenantId']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FiltroUpdateDTOToJSON(requestParameters['filtroUpdateDTO']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async updateFiltro(requestParameters: UpdateFiltroRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateFiltroRaw(requestParameters, initOverrides);
    }

}
